const showInfo = () => {
  let currentTime = new Date().getTime()
  return currentTime >= 1600596000000
}
export default showInfo
